
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/file-manager",
      function () {
        return require("private-next-pages/file-manager.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/file-manager"])
      });
    }
  